import {
  OrdersRoute,
  ProfileRoute,
  RootRoute,
  WalletManagerRoute,
  WalletTrackerRoute,
  WatchlistRoute,
} from '@root/features/routing'
import { useTranslation } from '@root/shared/localization'
import {
  CandleChartOutlineIcon,
  ExploreIcon,
  ProfileIcon,
  StarOutlineIcon,
  WalletOutlineIcon,
  WalletTrackerAlertIcon,
} from '@root/shared/ui-kit'

import { BottomNavigationContainer } from './bottom-navigation-container'
import { BottomNavigationItem } from './bottom-navigation-item'

export const BottomNavigationExplore: React.FC = () => {
  const { t } = useTranslation()

  return (
    <BottomNavigationContainer>
      <BottomNavigationItem
        title={t('common.explore')}
        icon={ExploreIcon}
        to={RootRoute.path}
      />
      <BottomNavigationItem
        title={t('trading.navigation.orders')}
        icon={CandleChartOutlineIcon}
        to={OrdersRoute.path}
      />
      <BottomNavigationItem
        title={t('common.profile')}
        icon={ProfileIcon}
        to={ProfileRoute.build({})}
      />
      <BottomNavigationItem
        title={t('navigation.wallet-tracker')}
        icon={WalletTrackerAlertIcon}
        to={WalletTrackerRoute.path}
      />
      <BottomNavigationItem
        title={t('wallet_other')}
        icon={WalletOutlineIcon}
        to={WalletManagerRoute.path}
      />
      <BottomNavigationItem
        title={t('trading.navigation.favorites')}
        icon={StarOutlineIcon}
        to={WatchlistRoute.path}
      />
    </BottomNavigationContainer>
  )
}
